import { symbolToken } from '@servicetitan/react-ioc/dist/common';

export const USE_WINDOW_TOKEN = symbolToken<string>('USE_WINDOW_TOKEN', false);
export const USE_MODE_TOKEN = symbolToken<string>('USE_MODE_TOKEN', false);
